import React from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

const AdminNotificationPage = () => {
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-12 col-12">
                <div className="card rounded-1">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">Send Notifications</h5>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <form action="#" className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label for="title">Notification Title</label>
                          <input
                            type="text"
                            className="form-control"
                            id="title"
                            placeholder="NotificationTitle"
                          />
                        </div>
                      </div>
                      <div className="col-md-12 ">
                        <div className="form-group">
                          <label for="message">Notification Details</label>
                          <textarea
                            className="form-control"
                            id="message"
                            rows="5"
                            placeholder="Notification Message"
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label for="message">Send Notification To</label>
                          <select
                            className="form-select"
                            aria-label="Default select example"
                          >
                            <option value="1">All</option>
                            <option value="2">Customers/Users</option>
                            <option value="3">Shops</option>
                            <option value="4">Drivers</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <button type="submit" className="btn btn-success">
                          Send Notification
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminNotificationPage;
